import React from 'react'
import styled from 'styled-components'
import Settings from '../Settings'
import { RowBetween } from '../Row'
import { TYPE } from '../../theme'
import ShowChart from '../../assets/svg/show-chart.svg'
import HideChart from '../../assets/svg/hide-chart.svg'

const StyledSwapHeader = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.text2};
`

export default function SwapHeader({ onShowChart, isShowChart }: { onShowChart: () => void; isShowChart: boolean }) {
  return (
    <StyledSwapHeader>
      <RowBetween>
        <TYPE.largeHeader fontWeight={500} color={'#fff'}>
          Swap
        </TYPE.largeHeader>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Settings />
          <img
            src={isShowChart ? HideChart : ShowChart}
            alt="show-chart"
            style={{ width: '24px', height: '24px', cursor: 'pointer', color: '#fff' }}
            onClick={onShowChart}
          />
        </div>
      </RowBetween>
      <TYPE.subHeader fontWeight={400} color={'#D9D9D9'}>
        Instantly buy or sell tokens at superior prices
      </TYPE.subHeader>
    </StyledSwapHeader>
  )
}
